export const VALIDATE_USER_TOKEN_INTERVAL = 1000 * 60; // 1 minute

export enum COGNITO_CHALLENGE_NAME {
  newPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  smsMFA = 'SMS_MFA',
  softwareTokenMFA = 'SOFTWARE_TOKEN_MFA',
}
